import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Link, useNavigate } from "react-router-dom";
import sectionService from "../../services/section-service";
import { Divider, Spin } from "antd";
import { ToastContainer, toast } from 'react-toastify';
import Swal from "sweetalert2";

const AdminSection = () => {
  let navigate = useNavigate();
  const [farmName, setFarmName] = useState("");
  const [listSection, setListSection] = useState([]);
  const [showEdit, setShowEdit] = useState(false);
  const [showSave, setShowSave] = useState(true);
  const [loading, setLoading] = useState(false);
  const [title, setTitle] = useState(false);
  const [sessionUser, setSessionUser] = useState("admin");

  const {
    register,
    handleSubmit,
    setValue,
    getValues,
    reset,
    formState: { errors },
  } = useForm();

  const optionsState = [
    { id: true, name: "ACTIVA" },
    { id: false, name: "INACTIVA" },
  ];

  const goToAdminLots = (section) => {
    localStorage.setItem("sectionId", section._id);
    localStorage.setItem("sectionName", section.name);
    navigate("/admin-lots");
  };






  ////FUNCIONES QUE USAN EL SERVICIO sectionService
  ////FUNCIONES QUE USAN EL SERVICIO sectionService
  const getListByFarm = async () => {
    setLoading(true)
    const farm_id = localStorage.getItem("farmId");
    const listado = await sectionService.getListByFarm(farm_id);
    if (listado) {
      setListSection(listado);
    }
    setLoading(false)
  };

  const customSubmit = async (data) => {


    const data_insert = { ...data, name: data.sectionName }

    const pin = getValues("pin")
    if (pin != "2525") {
      toast.error('Usuario sin privilegios!', { autoClose: 1000 });
      return;
    }


    setLoading(true)
    await sectionService.insert(data_insert);
    setValue("sectionName", "");
    setValue("state", true);
    await getListByFarm();
    toast('Realizado.', { autoClose: 1000 });
    setLoading(false)
  };

  const getSection = async (sectionId) => {
    const section = await sectionService.get(sectionId);
    if (section) {
      setValue("id", section._id);
      setValue("farmId", section.farmId);
      setValue("farmName", section.farmName);
      setValue("sectionName", section.name);
      setValue("state", section.state);
      setShowEdit(true);
      setShowSave(false);
    }
  };

  const updateLot = async () => {
    setLoading(true)
    const id = getValues("id");
    const name = getValues("sectionName");
    const state = getValues("state");
    const data = { id, name, state };
    const success = await sectionService.update(data);
    if (success) {
      getListByFarm();
      cancelar();
      toast('Realizado.', { autoClose: 1000 });
    }
    setLoading(false)
  };

  const cancelar = async () => {
    setShowEdit(false);
    setShowSave(true);
    setValue("sectionName", "");
    setValue("state", true);
  };


  const capitalizeWords = (e) => {
    let value = e.target.value;
    value = value
      .split(' ') // Divide el texto en palabras
      .map(word =>
        word.charAt(0).toUpperCase() + word.slice(1).toLowerCase() // Capitaliza la primera letra de cada palabra
      )
      .join(' ');
    setValue("sectionName", value);
  };

  const nameToUpper = (e) => {
    let value = e.target.value.toUpperCase();
    setValue("sectionName", value);
  };




  const deleteSection = async (id, name) => {
    const username = localStorage.getItem("username");
    if (username != "superadmin") {
      toast.error('Usuario sin privilegios.', { autoClose: 1000 });
      return;
    }
    else {
      Swal.fire({
        title: `Eliminar  seccion`,
        html: `Desea eliminar ${name}, sus lotes, lineas y palmas? <br/> <em>(Solo puede eliminar secciones sin tareas asociadas)</em> `,
        showDenyButton: false,
        showCancelButton: true,
        confirmButtonText: "Eliminar",
        denyButtonText: `Conservar`
      }).then(async (result) => {
        if (result.isConfirmed) {
          setLoading(true)
          const data = { id };
          const response = await sectionService.deleteSection(data);
          if (response.success) {
            const farm_id = localStorage.getItem("farmId");
            getListByFarm(farm_id);
            toast(response.message, { autoClose: 1000 });
          }
          else {
            toast.error(response.error, { autoClose: 1000 });
          }
          setLoading(false)
        }
      });
    }
  }




  useEffect(() => {
    const farm_id = localStorage.getItem("farmId");
    const farm_name = localStorage.getItem("farmName");
    setTitle(farm_name)
    setFarmName(farm_name);
    setValue("farmId", farm_id);
    setValue("farmName", farm_name);
    getListByFarm(farm_id);


    setValue("sectionName", "");
    setValue("pin", "");
    const username = localStorage.getItem("username");
    setSessionUser(username)
    if (username == "superadmin") {
      setValue("pin", "2525")
    }


  }, []);



  return (
    <div className="row p-4">
      <ToastContainer />

      <div className="col-12 " style={{ marginTop: "-10px" }}>


        <Divider
          orientation="left"
          style={{
            borderColor: "#AAAAAA"
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px"
            }}
          >
            <span>FINCA: {title}</span>

            <Link
              to="/admin-farms"
              className="nav-link link-primary p-1"
            >
              <i className="bi bi-arrow-left-short fa-lg"></i>

              <span className="fs-6 m-1">
                <strong>
                  REGRESAR A FINCAS
                </strong>
              </span>
            </Link>
          </div>
        </Divider>
      </div>





      <div className="col-12 col-sm-4">
        <div className="card p-4">
          <form className="form-react" onSubmit={handleSubmit(customSubmit)}>
            <div className="row">
              <div className="card-title">
                <h3 className="text-secondary" >Datos de la sección</h3>
                <hr></hr>
              </div>

              <div className=" col-12 d-none">
                <label>Id Seccion</label>
                <input
                  readOnly={true}
                  type="text"
                  className="form-control bg-light"
                  {...register("id")}
                />
              </div>

              <div className=" col-12 d-none">
                <label>Id Finca</label>
                <input
                  readOnly={true}
                  type="text"
                  className="form-control bg-light"
                  {...register("farmId")}
                />
              </div>

              <div className=" col-12">
                <label>Finca</label>
                <input
                  readOnly={true}
                  type="text"
                  className="form-control bg-light"
                  {...register("farmName")}
                />
              </div>

              <div className=" col-12">
                <label>Nombre de sección</label>
                <input
                  type="text"
                  onKeyUp={nameToUpper}
                  className="form-control"
                  {...register("sectionName", { required: true, minLength: 3 })}
                />
                {errors.name?.type === "required" && (
                  <small className="text-danger">Campo requerido</small>
                )}
                {errors.name?.type === "minLength" && (
                  <small className="text-danger">Minimo 3 caracteres</small>
                )}
              </div>



              <div className=" col-6">
                <label>PIN</label>
                <input
                  type="password"
                  autoComplete="off"
                  className="form-control bg-light"
                  {...register("pin")}
                />
              </div>


              <div className=" col-6">
                <label>Estado</label>
                <select className="form-control" {...register("state")}>
                  {optionsState.map((option) => (
                    <option key={option.id} value={option.id}>
                      {option.name}
                    </option>
                  ))}
                </select>
              </div>

              <div className={showEdit ? " col-6" : "d-none"}>
                <label>&nbsp; </label>
                <Spin spinning={loading}>
                  <button
                    className="btn btn-primary w-100"
                    type="button"
                    onClick={() => updateLot()}
                  >
                    <i className="bi bi-save fa-lg m-2" /> Editar
                  </button>
                </Spin>
              </div>

              <div className={showSave ? " col-6" : "d-none"}>
                <label>&nbsp; </label>
                <Spin spinning={loading}>
                  <button className="btn btn-primary w-100" type="submit">
                    <i className="bi bi-save fa-lg m-2" /> Guardar
                  </button>
                </Spin>
              </div>

              <div className=" col-6">
                <label>&nbsp; </label>
                <Spin spinning={loading}>
                  <button
                    className="btn btn-secondary w-100"
                    type="button"
                    onClick={() => cancelar()}
                  >
                    <i className="bi bi-x-square fa-lg m-2" /> Cancelar
                  </button>
                </Spin>
              </div>
            </div>
          </form>
        </div>

      </div>


      <div className="col-12 col-sm-6">

        <div className="card p-4">
          <div className="card-title">
            <h3 className="text-secondary mx-3" >Listado de secciones</h3>
            <hr></hr>
            <div className="tbl-container bdr">
              <Spin spinning={loading}>
                <table className="table ">
                  <thead className="table-primary">
                    <tr>
                      <th>Nombre</th>
                      <th>Hectáreas</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {listSection.map((section) => (
                      <tr key={section._id}>
                        <td>{section.name}</td>
                        <td>{section.hectares}</td>
                        <td style={{ width: "295px" }}>
                          <button
                            className="btn btn-primary"
                            onClick={() => getSection(section._id)}
                          >
                            <i className="bi bi-pencil-square fa-lg m-1" /> Editar
                          </button>


                          <button
                            className="btn btn-primary ms-2"
                            onClick={() => goToAdminLots(section)}
                          >
                            <i className="bi bi-card-checklist fa-lg m-2" />Gestionar lotes
                          </button>



                          <button
                            className={sessionUser == "superadmin" ? "btn btn-danger ms-2 fs-6" : "d-none"}
                            onClick={() => deleteSection(section._id, section.name)}
                          >
                            <i className="bi bi-trash fa-lg m-2" />
                          </button>


                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </Spin>
            </div>
          </div>
        </div>
      </div>



    </div>
  );
};

export default AdminSection;
